import { ProductTier, useCurrentCompany } from '@bonusly/who-am-i';

export const useHomepageRedesignEnabled = () => {
	// check product tier to determine if homepage redesign is enabled
	// it is enabled for tier_free, tier_alpha and tier_three
	const company = useCurrentCompany();
	return [ProductTier.TierFree, ProductTier.TierAlpha, ProductTier.TierThree].includes(company?.product_tier);
};
